import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Button, notification, Spin, Typography } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

import { login } from '../../API/auth';
import { recoveryPassword } from '../../API/password'
import { useAuth } from "../Context/AuthContext";
import logo from './assets/logo-login.svg'
import './Login.css';

const { Title, Text } = Typography;

const Login = ({ onLogin }) => {
  const [api, contextHolder] = notification.useNotification();
  const { login: loginAuth } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      api.error({
        message: "Acceso no permitido",
        description: "El login desde dispositivos móviles no está permitido."
      });
      return;
    }
    setLoading(true);
    try {
      const response = await login(email, password);
      loginAuth(response.user);
      const { password_status } = response.user;
      if (password_status?.force_change || password_status?.is_expired) {
        navigate('/reset-password', {
          state: { email: response.user.email, showNotification: true }
        });
      } else {
        api.success({ message: "Inicio de sesión exitoso" });
        onLogin();
        navigate('/home');
      }
    } catch (error) {
      let errorMessage = "Usuario o contraseña inválido";

      if (error?.response?.data?.non_field_errors?.length) {
        errorMessage = error.response.data.non_field_errors[0];
      }

      api.error({
        message: errorMessage,
        key: 'save-login-error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRecoveryPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      api.error({ message: "Por favor ingrese su correo electrónico" });
      return;
    }
    try {
      await recoveryPassword(email);
      api.success({
        message: "Solicitud enviada",
        description: "Si el correo existe, recibirás instrucciones para recuperar tu contraseña."
      });
      setForgotPassword(false);
    } catch (err) {
      api.error({ message: "Error al intentar recuperar la contraseña" });
    }
  };

  return (
    <>
      {contextHolder}
      <div className="login-page">
        <img src={logo} alt="Logo de la aplicación" className="app-logo" />

        {!forgotPassword ? (
          <form onSubmit={handleSubmit} className="login-form">
            <Input
              placeholder="Usuario o Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              size="large"
              className="input-box"
            />

            <Input.Password
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              size="large"
              className="input-box"
              iconRender={(visible) =>
                visible ? (
                  <EyeTwoTone twoToneColor="#91D500" />
                ) : (
                  <EyeInvisibleOutlined style={{ color: "#93d534" }} />
                )
              }
            />

            <Button 
              htmlType="submit" 
              className="login-btn" 
              disabled={loading} 
              size="large"
              block
            >
              {loading ? <Spin className="custom-login-spin" size="small" /> : "Iniciar Sesión"}
            </Button>

            <span 
              className="forgot-password" 
              onClick={() => setForgotPassword(true)}
              style={{ cursor: "pointer" }}
            >
              Olvidé mi contraseña
            </span>
          </form>
        ) : (
          <form onSubmit={handleRecoveryPassword} className="login-form">
            <h2 className="recovery-title">¿Olvidaste tu contraseña?</h2>
            <p className="recovery-text">
              Ingresa tu correo electrónico o usuario y te ayudaremos a recuperarla.
            </p>

            <Input
              type="text"
              placeholder="Usuario o Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              size="large"
              className="input-box"
            />

            <div style={{ display: "flex", gap: "15px" }}>
              <Button className="cancel-btn" onClick={() => setForgotPassword(false)}>
                Cancelar
              </Button>
              <Button htmlType="submit" className="recovery-btn">
                Recuperar
              </Button>
            </div>
          </form>
        )}
      </div>
    </>
  );
};

export default Login;